import { createFileRoute } from '@tanstack/react-router';
import { AdminLandingPage } from '@/pages/admin/AdminLandingPage';

/**
 * `/admin` schickt weiter — wohin, hängt an der Rolle (ADR 0042). Deshalb
 * eine Komponente statt eines `beforeLoad`-Redirects: der Wächter dort kennt
 * das Profil noch nicht.
 */
export const Route = createFileRoute('/admin/')({
  component: AdminLandingPage
});
